import React from "react";
import { Box } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export const ExtendIcon = () => (
  <Box position="relative" display="inline-flex">
    <CalendarTodayIcon fontSize="small" />
    <AddIcon
      sx={{
        position: "absolute",
        fontSize: '18px',
        top: '13%',
        left: '5%',
        borderRadius: "50%",
      }}
    />
  </Box>
);

export const AmendIcon = () => (
  <Box position="relative" display="inline-flex" sx={{ position:'relative'}}>
    <CalendarTodayIcon fontSize="small" />
    <RemoveIcon      
      sx={{
        position: "absolute",
        fontSize: '18px',
        top: '10%',
        left: '7%',
        borderRadius: "50%",
      }}
    />
  </Box>
);
